<template>
  <main class="home">
    <Header
      navbarType="goBack"
      :screenTitle="screenTitle"
      @clicked="goBack()"
    />
    <div class="p-4">
      <h5 class="mt-5 text-center">{{ t("WITHDRAWAL_FROZEN_HEADER") }}</h5>
      <img
        :src="`${useAsset('img/credit-line/sorryno.png')}`"
        class="mx-auto d-block"
        alt="sorry"
      />
      <p class="mt-5 text-center">{{ description }}</p>
    </div>
  </main>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import Header from "@/shared-components/consumer/Header.vue";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import useAsset from "@/apps/credit-line/helpers/useAsset";
import { useCreditLineSummary } from "@/apps/credit-line/hooks/useCreditLineSummary";
import { useRouter } from "vue-router";
import {
  AvailableFeatures,
  FeatureControlService,
} from "@/apps/credit-line/services/feature-control.service";
import { AndroidInterface } from "@/apps/credit-line/services/android.service";
declare const Android: AndroidInterface;

export default defineComponent({
  name: "WithdrawalFrozen",
  components: {
    Header,
  },
  setup() {
    const { t } = useI18n();
    const router = useRouter();
    const featureService = new FeatureControlService();
    const { fetchSummary } = useCreditLineSummary();
    const screenTitle = ref("");
    let description = ref("");

    onMounted(() => {
      fetchSummary().then((summary) => {
        if (summary) {
          const wpNumber = featureService.getFeatureValue(
            AvailableFeatures.WHATSAPP,
            summary.country,
            "number"
          );
          description.value =
            history.state?.message ||
            t("WITHDRAWAL_FROZEN_DESCRIPTION", {
              PHONE_NUMBER: wpNumber,
            });
        } else {
          router.replace({
            name: "CreditLineApiErrorDisplay",
            query: {
              title: t("PAYJOY_CARD_VIEWS.ACTIVATION_ERROR_TITLE"),
            },
          });
        }
      });
    });

    const goBack = () => {
      Android.dismissWebView();
    };

    return {
      t,
      screenTitle,
      description,
      goBack,
      useAsset,
    };
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";

.disabled-button {
  opacity: 0.5;
}
</style>
